import {useCallback, useState} from 'react';
import {ApiClientService, useAuth} from '@dofleini/security';
import {useMutation} from 'react-query';
import Authorization from '../services/Auth.api.service';
import {setAuthData} from '../utils/storage.utils';

export const useLogin = () => {
  const {reload} = useAuth();
  const [isLoading, setLoading] = useState(false);
  const {mutateAsync, isError, data, error} = useMutation(Authorization.signIn);

  const onSignIn = useCallback(async (body) => {
    try {
      setLoading(true);
      const {data} = await mutateAsync(body);
      setAuthData(data);
      ApiClientService.setToken(data.accessToken, body.remember);
      if (data.space)
        ApiClientService.setSpace(data.space);
      await reload();
    } catch {
      setLoading(false);
      //ignoring
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let errorMessage;
  if (error) {
    errorMessage = !error.status ? 'login.network' : 'login.generalError';
    if (error?.response?.data?.error === 'UNAUTHORIZED')
      errorMessage = 'login.unauthorized';

    if (error.status === 401)
      errorMessage = error?.response?.data?.error === 'USER_NOT_VERIFIED' ? 'login.notVerified' : 'login.badCredentials';
  }

  return {
    onSignIn,
    isLoading,
    isError,
    data,
    error: errorMessage
  };
};

const errors = {
  'Duplicated email': 'signup.duplicated',
  'Access request already exist. Duplicated email.': 'request.requestDuplicated',
  'Duplicated identifier': 'request.duplicated',
  'Duplicated email or phone': 'signup.duplicated'
};

export const useSignUp = (callback) => {
  const {mutateAsync, isLoading, isError, data, error} = useMutation(Authorization.signUp);

  const onSignUp = useCallback(async (body) => {
    try {
      const {data} = await mutateAsync(body);
      callback && callback(data.email);
    } catch {
      //ignoring
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);

  const duplicated = errors[error?.response?.data?.message] || '';

  return {
    onSignUp,
    isLoading,
    isError,
    data,
    error: duplicated || (error && (error.status === 401 ? 'signup.permission' : !error.status ? 'login.network' : 'signup.generalError'))
  };
};

export const useResendConfirmation = (callback) => {
  const {
    mutateAsync,
    isLoading,
    isError,
    data,
    error
  } = useMutation(Authorization.resendConfirmationAccessFromStorage);

  const onResendConfirmation = useCallback(async (body) => {
    try {
      const {data} = await mutateAsync(body);
      callback && callback(data);
    } catch {
      //ignoring
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);


  return {
    onResendConfirmation,
    isLoading,
    isError,
    data,
    error: error && (error.status === 401 ? 'login.badCredentials' : !error.status ? 'login.network' : 'login.generalError')
  };
};


export const useRequestAccess = (callback) => {
  const {mutateAsync, isLoading, isError, data, error} = useMutation(Authorization.requestAccess);

  const request = useCallback(async (body) => {
    try {
      await mutateAsync(body);
      callback && callback(body.identifier);
    } catch {
      //ignoring
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback]);

  const duplicated = errors[error?.response?.data?.message] || '';

  return {
    request,
    isLoading,
    isError,
    data,
    error: duplicated || (error && (error.status === 401 ? 'signup.permission' : !error.status ? 'login.network' : 'signup.generalError'))
  };
};
